import { render, staticRenderFns } from "./custom-loader.vue?vue&type=template&id=4dc1bfd1"
import script from "./custom-loader.vue?vue&type=script&lang=js"
export * from "./custom-loader.vue?vue&type=script&lang=js"
import style0 from "./custom-loader.vue?vue&type=style&index=0&id=4dc1bfd1&lang=css"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/frontend_src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dc1bfd1')) {
      api.createRecord('4dc1bfd1', component.options)
    } else {
      api.reload('4dc1bfd1', component.options)
    }
    module.hot.accept("./custom-loader.vue?vue&type=template&id=4dc1bfd1", function () {
      api.rerender('4dc1bfd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "custom-loader.vue"
export default component.exports